import { IconWarningCircle, StatusHint, TextLink } from '@indipia/ui-core'
import { hasUnsent, listLineText, type CustReqCounts } from '@indipia/shared-features'

// 리스트 펼침 영역의 '고객 요청' 줄 — 'n건 · 반영 n · 미전달 n'(없으면 '없음') + '공종 상세창에서 보기 ›'.
// 집계 실패(값 null)면 줄 전체를 그리지 않는다(null 반환, 오류 표시 없음). 등록·수정은 여기서 하지 않고 상세창에서 한다.

export interface ScheduleListCustReqLineProps {
  counts: CustReqCounts
  /** 공종 상세창(고객 요청 카드)을 연다. 없으면 링크를 숨긴다 */
  onOpenDetail?: () => void
}

export function ScheduleListCustReqLine({ counts, onOpenDetail }: ScheduleListCustReqLineProps) {
  const text = listLineText(counts)
  if (text === null) return null
  const unsent = hasUnsent(counts.unsentCount)
  return (
    <>
      <StatusHint
        tone={unsent ? 'warning' : 'muted'}
        icon={unsent ? <IconWarningCircle width={14} height={14} /> : undefined}
      >
        {text}
      </StatusHint>
      {onOpenDetail && <TextLink onClick={onOpenDetail}>공종 상세창에서 보기 ›</TextLink>}
    </>
  )
}

/** 줄을 그릴지 여부(Expand 의 줄 머리말까지 함께 숨기기 위한 판정) */
export function hasCustReqLine(counts: CustReqCounts): boolean {
  return listLineText(counts) !== null
}
